import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const LibraryIcon = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({
  "data-test-id": "vertical-nav-icon__library"
}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "m11.9,6.5l.73,3.12c.29,1.35,1.69,1.18,3.06,1.18h11.82c.27,0,.48.22.48.48v13.39c0,.46-.37.83-.83.83H4.71c-.39,0-.71-.32-.71-.71v-15.81l.42-2.48h7.48m.72-2H3.88c-.79,0-1.1.23-1.29.81l-.57,3.4s-.02.09-.02.2v17.6c0,.54.44.98.98.98h26.04c.54,0,.98-.44.98-.98V9.78c0-.54-.44-.98-.98-.98h-13.42c-1.06,0-1.14-.55-1.14-.55l-.76-2.94c-.13-.45-.19-.81-1.08-.81h0Z"
  })
}));
export default LibraryIcon;